import { LabelChipProps } from "./types/labelChipProps";
import "./labelChip.scss";

const LabelChip = (props: LabelChipProps) => {
    let className = `labelChip txt-chips ${props.mainClass}`;
    return (<div className={className}>
        {props.text}
    </div>)
}

export default LabelChip;